export const getOrganizationsUrl = () => '/public/organizations';

export const getAgencyOrganizationsUrl = () => '/agency/organizations';
